import { LOGIN, LOGOUT } from "../Action/auth";

const initialState = {
  token: null,
  type: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN: {
      const { token, userType } = action;

      return {
        ...state,
        token,
        type: userType,
      };
    }
    case LOGOUT:
      return initialState;
    default:
      return { ...state };
  }
};
